import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";
import { CheckCircleIcon, CloseIcon, JMLogo } from "@/constant/imagePath";
import { cn } from "@/utils/cn";
import BaseModal from "../BaseModal";

const SuccessModal = forwardRef((_, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [countdown, setCountdown] = useState(2);
  const [percentage, setPercentage] = useState(100);

  useImperativeHandle(ref, () => ({
    open: (msg) => {
      setMessage(msg);
      setIsOpen(true);
      setCountdown(2);
      setPercentage(100);
    },
    close: () => setIsOpen(false),
  }));

  useEffect(() => {
    if (isOpen) {
      const totalDuration = 2000;
      const interval = 100;
      const decrement = 100 / (totalDuration / interval);

      const timer = setInterval(() => {
        setCountdown((prev) => {
          const newCountdown = Math.max(prev - interval / 1000, 0);
          if (newCountdown === 0) {
            clearInterval(timer);
            setIsOpen(false);
          }
          return newCountdown;
        });
        setPercentage((prev) => Math.max(prev - decrement, 0));
      }, interval);

      return () => clearInterval(timer);
    }
  }, [isOpen]);

  return (
    <BaseModal
      isOpen={isOpen}
      isFetching={false}
      onClose={() => setIsOpen(false)}
      width="520px"
      height="261px"
    >
      <div className="flex flex-col h-full w-full ">
        <div className="w-full justify-between items-center flex">
          <img
            src={JMLogo}
            alt="JMLogo"
            className={cn("transition-all duration-300 w-10 h-5")}
          />
          <button
            className="disabled:opacity-50 active:opacity-80"
            onClick={() => setIsOpen(false)}
          >
            <img src={CloseIcon} alt="icon" />
          </button>
        </div>
        <div className="flex-1 flex items-center justify-center flex-col gap-y-5">
          <img src={CheckCircleIcon} alt="CheckCircleIcon" />
          <p className="font-light text-center">{message}</p>
        </div>
        <div className="h-[38px] justify-center flex items-center gap-x-4">
          <button
            onClick={() => setIsOpen(false)}
            className="w-[230px] relative disabled:opacity-70 active:opacity-90 bg-green-black-gradient text-white h-full rounded-7 font-light "
          >
            <div
              className="absolute h-full inset-0 bg-black opacity-30 rounded-l-7"
              style={{
                width: `${percentage}%`,
                transition: "width 100ms linear",
              }}
            ></div>
            <span className="relative z-10">Done</span>
          </button>
        </div>
      </div>
    </BaseModal>
  );
});

export default SuccessModal;
